import {userProfileManager} from '../../util/user-profile-manager';

export var OrderHistoryDetailsService = function($http, $q, accountConfigManager, orderNumber) {
    var orderInfo = {};

    var countryCode = accountConfigManager.site['countryCode'];

    var jwt_token = userProfileManager.getJWT();

    var orderDetailsServiceEndPoint = '/shop-service/api/v2/order/'
        + orderNumber + '?cntryCd=' + countryCode + '&eid=' + jwt_token;

    var headerConfig = {
        headers: {
            'content-type': 'application/json',
            'showgloballoader': true,
            'client_id': accountConfigManager.system['mulesoft.client_id'],
            'client_secret': accountConfigManager.system['mulesoft.client_secret']
        }
    };

    orderInfo.getOrderHistoryDetails = function() {
        var url = orderDetailsServiceEndPoint;
        return $http.get(url, headerConfig);
    };

    return orderInfo;
};



//////////////////
// WEBPACK FOOTER
// /Users/geoffsagers/dev/webcomponents/js/packages/common-account/src/angular/services/order-history-details-service.js
// module id = 242
// module chunks = 0